// removed by extract-text-webpack-plugin
module.exports = {"heading":"_3vayzBF8GhVgCu2SP6NAVQ","small":"_34lMP3Z7rx8kaQZLzcy7yQ","block-wrapper":"yu7juUx3p5byHCP6mmcjj","contacts":"fNSprVBdHn7abPm-tMW0o","circle":"luXSvOQj-kXq35CyTkroH","circle-large":"iXA1Y6UiEvy-04kukPy3Z","person-block":"_3igp8Sfcc5v7aF0OnJjs_6","left-aligned":"pS-JQJvp1MwAPZh15szmq","info":"lhRzWr5PkwrkTrNTDliFX","name":"_2LMCNNAuwLFCxUDJMc9enU","title":"_3QX7CaKiGpMVukjVAcfTT4","department":"_1_zxxs8RACcooGYzO5Mlov","contact-info":"vrIwBqnGkEYOTNONteuT-","no-image":"UXsqHGo5_8nHJSI_j0mtv","detailed-info":"_3HxyNvrIa6ka1leaqt9iBd","see-all-link":"_1JHp4vWMXp6WFJ5SiwVuU3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ContactBlock/ContactBlock.module.scss
// module id = 742
// module chunks = 0